import { render, staticRenderFns } from "./CenterSelect.vue?vue&type=template&id=4c672da2&scoped=true"
import script from "./CenterSelect.vue?vue&type=script&lang=js"
export * from "./CenterSelect.vue?vue&type=script&lang=js"
import style0 from "./CenterSelect.vue?vue&type=style&index=0&id=4c672da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c672da2",
  null
  
)

export default component.exports